import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminConcurrencyKeyDetailsPage } from '../../../../../../components/pages/backoffice/platform/platform-admin-jobs-page/concurrency-key-details-page/platform-admin-concurrent-key-details-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/jobs/$jobId/$concurrencyKey/')({
  component: function Component() {
    const { jobId, concurrencyKey } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['tech.configurations']}>
        <PlatformAdminConcurrencyKeyDetailsPage jobId={jobId} concurrencyKey={concurrencyKey} />
      </PermissionChecker>
    )
  },
})
